/** Legacy cards have no generated-title flag. Only replace an exact measure label or
 * its standard “by …” title; preserve authored prose and qualifiers. */
export function titleAfterMeasureChange(title: string, previousLabel?: string, nextLabel?: string): string {
  if (!previousLabel || !nextLabel || previousLabel === nextLabel) return title;
  if (title === previousLabel) return nextLabel;
  if (title.startsWith(`${previousLabel} by `)) return `${nextLabel}${title.slice(previousLabel.length)}`;
  return title;
}
